import { render, staticRenderFns } from "./alerts-panel.vue?vue&type=template&id=27f0e60c&scoped=true&lang=pug"
import script from "./alerts-panel.vue?vue&type=script&lang=js"
export * from "./alerts-panel.vue?vue&type=script&lang=js"
import style0 from "./alerts-panel.vue?vue&type=style&index=0&id=27f0e60c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f0e60c",
  null
  
)

export default component.exports